export default "__VITE_ASSET__dc9b2d54__"